import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import axios from "axios";
// import { useHistory } from "react-router-dom";

// const history = useHistory();

// const handleLogin = () => {
//   window.location.href = '/dashboard';

//   // history.push('/dashboard');
// };
function showPassword() {
  var x = document.getElementById("split-login-password");
  var btn = document.getElementById("eye-pwd");
  if (x.type === "password") {
    x.type = "text";
    btn.innerHTML = `<svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.61236 4.5599C8.87544 4.51957 9.14122 4.49951 9.40737 4.4999C11.7924 4.4999 14.0349 6.21739 15.3399 8.99989C15.1403 9.42334 14.9149 9.83411 14.6649 10.2299C14.5855 10.3528 14.5438 10.4961 14.5449 10.6424C14.5465 10.8061 14.6017 10.9647 14.702 11.0941C14.8022 11.2235 14.9421 11.3165 15.1001 11.359C15.2582 11.4015 15.4258 11.3911 15.5775 11.3294C15.7291 11.2678 15.8564 11.1582 15.9399 11.0174C16.2893 10.4683 16.5928 9.89138 16.8474 9.29239C16.8876 9.19881 16.9084 9.09801 16.9084 8.99614C16.9084 8.89428 16.8876 8.79348 16.8474 8.69989C15.3324 5.18239 12.4824 2.99989 9.40737 2.99989C9.05537 2.99812 8.70393 3.02824 8.35737 3.08989C8.25887 3.10664 8.16464 3.14262 8.08006 3.19578C7.99547 3.24894 7.92218 3.31824 7.86438 3.39972C7.80657 3.4812 7.76539 3.57328 7.74316 3.67068C7.72094 3.76808 7.71812 3.8689 7.73487 3.96739C7.75161 4.06589 7.78759 4.16012 7.84075 4.2447C7.89391 4.32929 7.96321 4.40258 8.04469 4.46038C8.12617 4.51819 8.21825 4.55937 8.31565 4.5816C8.41305 4.60382 8.51387 4.60664 8.61236 4.58989V4.5599ZM3.18987 1.71739C3.11994 1.64747 3.03692 1.592 2.94555 1.55415C2.85419 1.5163 2.75626 1.49683 2.65737 1.49683C2.55847 1.49683 2.46055 1.5163 2.36918 1.55415C2.27781 1.592 2.19479 1.64747 2.12487 1.71739C1.98364 1.85862 1.9043 2.05017 1.9043 2.24989C1.9043 2.44962 1.98364 2.64117 2.12487 2.78239L4.44987 5.0999C3.38905 6.12104 2.54476 7.34539 1.96737 8.69989C1.92607 8.79452 1.90475 8.89665 1.90475 8.99989C1.90475 9.10314 1.92607 9.20527 1.96737 9.29989C3.48237 12.8174 6.33237 14.9999 9.40737 14.9999C10.7552 14.9906 12.0712 14.5893 13.1949 13.8449L15.6249 16.2824C15.6946 16.3527 15.7775 16.4085 15.8689 16.4466C15.9603 16.4846 16.0584 16.5042 16.1574 16.5042C16.2564 16.5042 16.3544 16.4846 16.4458 16.4466C16.5372 16.4085 16.6201 16.3527 16.6899 16.2824C16.7602 16.2127 16.816 16.1297 16.854 16.0383C16.8921 15.9469 16.9117 15.8489 16.9117 15.7499C16.9117 15.6509 16.8921 15.5529 16.854 15.4615C16.816 15.3701 16.7602 15.2871 16.6899 15.2174L3.18987 1.71739ZM7.95987 8.60989L9.79737 10.4474C9.67061 10.4837 9.53923 10.5014 9.40737 10.4999C9.00954 10.4999 8.62801 10.3419 8.34671 10.0606C8.0654 9.77925 7.90737 9.39772 7.90737 8.99989C7.90583 8.86803 7.92352 8.73665 7.95987 8.60989ZM9.40737 13.4999C7.02237 13.4999 4.77987 11.7824 3.48237 8.99989C3.96693 7.93021 4.65467 6.96483 5.50737 6.15739L6.83487 7.49989C6.52305 8.06899 6.40417 8.72385 6.49606 9.36624C6.58795 10.0086 6.88565 10.6039 7.34451 11.0627C7.80337 11.5216 8.39864 11.8193 9.04102 11.9112C9.68341 12.0031 10.3383 11.8842 10.9074 11.5724L12.0999 12.7499C11.2832 13.2306 10.3549 13.4891 9.40737 13.4999Z" fill="#5945B3" />
    </svg>`

  } else {
    x.type = "password";
    btn.innerHTML = `<svg width="19" height="18" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_176_12398)">
<path d="M1.63184 12.125C1.63184 12.125 5.63184 4.125 12.6318 4.125C19.6318 4.125 23.6318 12.125 23.6318 12.125C23.6318 12.125 19.6318 20.125 12.6318 20.125C5.63184 20.125 1.63184 12.125 1.63184 12.125Z" stroke="#5945B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12.6318 15.125C14.2887 15.125 15.6318 13.7819 15.6318 12.125C15.6318 10.4681 14.2887 9.125 12.6318 9.125C10.975 9.125 9.63184 10.4681 9.63184 12.125C9.63184 13.7819 10.975 15.125 12.6318 15.125Z" stroke="#5945B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_176_12398">
<rect width="24" height="24" fill="white" transform="translate(0.631836 0.125)"/>
</clipPath>
</defs>
</svg>
`
    console.log();

  }
}
const Login = () => {
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [msg, setMsg] = useState();

  // const history = useHistory();

  // if (localStorage.getItem("amira-token")) {
  // history.push("/home");
  // }

  async function submitHandler() {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/user/login`,
        {
          email: email,
          password: password,
        }
      );
      if(response.data.status==="Success"){
      const {
        data: { jwt },
      } = response;
      console.log(response.data.data)
      localStorage.setItem("amira-token", jwt);
      window.location.href = '/#/dashboard';
    }else{
      let msg = <div className="alert alert-warning mt-2 p-2" role="alert">User email or password required</div>
      if (response.data.status === "Failure") {
        msg = <div className="alert alert-warning mt-2 p-2" role="alert">Invalid Email/Password</div>
      }
      if (!email) {
        msg = <div className="alert alert-warning mt-2 p-2" role="alert">User email required</div>
      } else if (!password) {
        msg = <div className="alert alert-warning mt-2 p-2" role="alert">Password required</div>
      }
      setMsg(msg);
    }
      // localStorage.setItem("email", response.data.data.email);
      // localStorage.setItem("password", response.data.data.password)
      // history.push("/home");
    } catch (err) {
      console.log(err);
      //tooltip here
      let msg = <div className="alert alert-warning mt-2 p-2" role="alert">User email or password required</div>
      if (err.response.data.status === "Failure") {
        msg = <div className="alert alert-warning mt-2 p-2" role="alert">Invalid Email/Password</div>
      }
      if (!email) {
        msg = <div className="alert alert-warning mt-2 p-2" role="alert">User email required</div>
      } else if (!password) {
        msg = <div className="alert alert-warning mt-2 p-2" role="alert">Password required</div>
      }
      setMsg(msg);
    }
  }
  return (
    <section className="vh-100 gradient-custom" >
      <div className="container py-5 h-100">
        <div className="row d-flex justify-content-center align-items-center h-100">
          <div className="col-12 col-md-8 col-lg-6 col-xl-5">
            <div className="card  text-black rounded">
              <div className="card-body p-5 text-center">
                <div className="mb-md-5 mt-md-4 ">
                  <h2 className="fw-bold mb-2 text-uppercase">Login</h2>
                  <p className="text-black-50 mb-4">Welecome To Amira Daneilli
                  </p>
                  <div className="form-outline form-white mb-4 text-start" >
                    <label className="form-label" htmlFor="typeEmailX">
                      Email
                    </label>
                    <input
                      type="email"
                      id="email"
                      className="form-control form-control-lg"
                      value={email}
                      onChange={(event) => setEmail(event.target.value)}
                    />
                  </div>
                  <div className="form-outline form-white mb-4">
                    {/* <div className="mb-3"> */}
                    <div className="d-flex justify-content-between">
                      <label className="form-label">Enter Password</label>
                    </div>
                    <div className="position-relative">
                      <input
                        className="form-control py-3 eye"
                        id="split-login-password"
                        name='password'
                        type="password"
                        value={password}
                        onChange={(event) => setPassword(event.target.value)}
                      />

                      <div
                        onClick={showPassword}
                        id="eye-pwd"
                        className=" m-t  position-absolute">
                        <svg width="19" height="18" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_176_12398)">
                            <path d="M1.63184 12.125C1.63184 12.125 5.63184 4.125 12.6318 4.125C19.6318 4.125 23.6318 12.125 23.6318 12.125C23.6318 12.125 19.6318 20.125 12.6318 20.125C5.63184 20.125 1.63184 12.125 1.63184 12.125Z" stroke="#5945B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M12.6318 15.125C14.2887 15.125 15.6318 13.7819 15.6318 12.125C15.6318 10.4681 14.2887 9.125 12.6318 9.125C10.975 9.125 9.63184 10.4681 9.63184 12.125C9.63184 13.7819 10.975 15.125 12.6318 15.125Z" stroke="#5945B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                          </g>
                          <defs>
                            <clipPath id="clip0_176_12398">
                              <rect width="24" height="24" fill="white" transform="translate(0.631836 0.125)" />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                    </div>
                  </div>
                  {msg}
                  {/* </div> */}
                  {/* <p className="small mb-5 pb-lg-2">
                    <a className="text-white-50" href="#!">
                      Forgot password?
                    </a>
                  </p> */}
                  <button className="btn btn-outline-secondary btn-lg px-5" type="submit" onClick={submitHandler} >
                    {/* <a href='/dashboard'> */}

                    Login
                    {/* </a> */}
                  </button>

                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Login;
